export function isDoorMockEnabled() {
  const params = new URLSearchParams(window.location.search);

  if (params.has("realDoor")) return false;
  if (params.has("mockDoor")) return true;

  return localStorage.getItem("mockDoor") === "true";
}

export function isWsMockEnabled() {
  const params = new URLSearchParams(window.location.search);

  if (params.has("realWs")) return false;
  if (params.has("mockWs")) return true;

  return localStorage.getItem("mockWs") === "true";
}
